import { CircleCheckIcon, CloudAlertIcon, Eye, NotebookPen, TriangleAlertIcon } from 'lucide-react';
import React from 'react';
import { Button, Modal } from 'rsuite';

export default function ExtraSlotDeleteModal({ open, handleClose, handleSave, slotData }) {
  const getDateFromISO = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const handleOnClickYes = async (event) => {
    event?.preventDefault();
    await handleSave(slotData?.slotData, slotData?.day, slotData?.index);
  };

  return (
    <div>
      <Modal backdrop='static' keyboard={false} open={open} onClose={() => handleClose(false)}>
        <Modal.Header>
          <div className='text-center'>
            {!slotData?.response ? (
              <TriangleAlertIcon style={{ color: '#FF0000', opacity: '50%', width: '40px', height: '40px', textAlign: 'center' }} />
            ) : slotData?.response?.success ? (
              <CircleCheckIcon style={{ color: '#243b86', opacity: '50%', width: '40px', height: '40px', textAlign: 'center' }} />
            ) : (
              <CloudAlertIcon style={{ color: '#FF0000', opacity: '50%', width: '40px', height: '40px', textAlign: 'center' }} />
            )}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className='center'>
            <h6 className='text-center' style={{ color: '#484848' }}>
              {slotData?.response
                ? slotData?.response?.message
                : slotData?.is_extra_slot
                ? 'Are you sure you want to delete this extra slot?'
                : 'Are you sure you want to delete this working slot?'}
            </h6>
          </div>
          {!slotData?.response ? (
            <div style={{ textAlign: 'center', marginTop: '32px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', marginTop: '16px' }}>
                <p style={{ color: '#484848', fontSize: '14px', fontWeight: '600' }}>
                  {slotData?.slotData?.location?.name}, <br />
                  {slotData?.slotData?.location?.address1}, {slotData?.slotData?.location?.address2 ? slotData?.slotData?.location?.address2 : ''}
                </p>
                <p style={{ color: '#484848', fontSize: '12px', fontWeight: '500' }}></p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: '16px', width: '55%', margin: 'auto' }}>
                <p style={{ color: '#484848', fontSize: '10px', fontWeight: '500' }}>
                  {' '}
                  {slotData?.is_extra_slot ? (
                    <>
                      Date : <span style={{ fontWeight: '700' }}>{getDateFromISO(slotData?.slotData?.created_at)}</span>
                    </>
                  ) : (
                    <>
                      Day : <span style={{ fontWeight: '700' }}>{slotData?.day}</span>
                    </>
                  )}
                </p>
                <p style={{ color: '#484848', fontSize: '10px', fontWeight: '500' }}>
                  {' '}
                  Start Time : <span style={{ fontWeight: '700' }}>{slotData?.slotData?.start_time}</span>
                </p>
                <p style={{ color: '#484848', fontSize: '10px', fontWeight: '500' }}>
                  {' '}
                  End Time : <span style={{ fontWeight: '700' }}>{slotData?.slotData?.end_time}</span>
                </p>
              </div>
            </div>
          ) : (
            <>
              {slotData?.response?.data && (
                <table className='table table-bordered table-hover mt-3'>
                  <thead>
                    <tr className='table-theme'>
                      <th className='table-theme'>Sno</th>
                      <th className='table-theme'>Name</th>
                      <th className='table-theme'>Hospital/Clinic</th>
                      <th className='table-theme'>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {slotData?.response?.data?.map((slot, index) => (
                      <tr key={index}>
                        <td className='align-content-center'>{index + 1}</td>
                        <td className='align-content-center'>
                          <a
                            className='text-decoration-none'
                            style={{ color: '#133696', cursor: 'pointer' }}
                            target='_blank'
                            href={`/patient/${slot?.patient?.id}/dashboard`}
                          >
                            {slot?.patient?.name}{' '}
                          </a>
                        </td>
                        <td className='align-content-center'>{slot?.location}</td>
                        <td className='align-content-center'>
                          {slot?.date}
                          <br />({slot?.start_time} - {slot?.end_time})
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </>
          )}
        </Modal.Body>
        {!slotData?.response && (
          <Modal.Footer>
            <Button onClick={handleOnClickYes} appearance='primary' style={{ width: '15%', backgroundColor: '#243b86' }}>
              Yes
            </Button>
            <Button onClick={() => handleClose(false)} appearance='primary' style={{ width: '15%', backgroundColor: '#484848', opacity: '60%' }}>
              No
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
}
